//import './App.css';
import Nav from "./components/Nav";
import Footer from "./components/Footer"
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Home from "./pages/Home";
import Books from "./pages/Books"
import { books } from "./data";
import BookInfo from "./pages/BookInfo";
import Cart from "./pages/Cart";
import { useState, useEffect } from "react";
import ScrollToTop from "../src/components/ui/ScrollToTop";

function App() {
  const [cart, setCart] = useState([]);

  function addToCart(book) {
    setCart([...cart, {...book, quantity: 1}])
  }

  function changeQuantity(book, quantity) {
    setCart(
      cart.map((item) => item.id === book.id
        ? {
          ...item,
          quantity: +quantity,
        }
      : item
    ))}

    function removeItem(item) {
      console.log("remove", item)
      setCart(cart.filter(book => book.id !== item.id))
    }

    function numberOfItems() {
      let counter = 0
      cart.forEach(item => {
        counter += item.quantity
      })
      return counter
    }

  useEffect (() => {
    console.log(cart)
  }, [cart])

  return (
    <Router>
    <div className="App">
      <ScrollToTop/>
      <Nav numberOfItems={numberOfItems()} />
      <Route path="/" exact component={Home} />
      <Route path="/books" exact render={() => <Books books={books} />} />
      <Route path="/books/:id" render={() => <BookInfo books={books} addToCart={addToCart} cart={cart} />} />
      <Route path="/cart" exact render={() => <Cart books={books} cart={cart} changeQuantity={changeQuantity} removeItem={removeItem} />} />
      
      <Footer />
    </div>
    </Router>
  );
}

export default App;

/*
import Landing from "./components/Landing";
import Highlights from "./components/Highlights";
import Featured from "./components/Featured";
import Discounted from "./components/Discounted"
import Explore from "./components/Explore"
*/